import _regeneratorRuntime from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { browser, cast, env, expandDims, image, reshape, tensor1d, tensor2d, tidy, util } from '@tensorflow/tfjs-core';
import { LazyIterator } from './lazy_iterator';
/**
 * Provide a stream of image tensors from webcam video stream. Only works in
 * browser environment.
 */

export var WebcamIterator = /*#__PURE__*/function (_LazyIterator) {
  _inherits(WebcamIterator, _LazyIterator);

  function WebcamIterator(webcamVideoElement, webcamConfig) {
    var _this;

    _classCallCheck(this, WebcamIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebcamIterator).call(this));
    _this.webcamVideoElement = webcamVideoElement;
    _this.webcamConfig = webcamConfig;
    _this.isClosed = true;
    _this.resize = false;

    if (_this.needToResize()) {
      _this.resize = true;
      _this.cropSize = [_this.webcamConfig.resizeHeight, _this.webcamConfig.resizeWidth];
      _this.cropBoxInd = tensor1d([0], 'int32');

      if (_this.webcamConfig.centerCrop) {
        // Calculate the box based on resizing shape.
        var widthCroppingRatio = _this.webcamConfig.resizeWidth * 1.0 / _this.webcamVideoElement.width;
        var heightCroppingRatio = _this.webcamConfig.resizeHeight * 1.0 / _this.webcamVideoElement.height;
        var widthCropStart = (1 - widthCroppingRatio) / 2;
        var heightCropStart = (1 - heightCroppingRatio) / 2;
        var widthCropEnd = widthCropStart + widthCroppingRatio;
        var heightCropEnd = heightCroppingRatio + heightCropStart;
        _this.cropBox = tensor2d([heightCropStart, widthCropStart, heightCropEnd, widthCropEnd], [1, 4]);
      } else {
        _this.cropBox = tensor2d([0, 0, 1, 1], [1, 4]);
      }
    }

    return _this;
  }

  _createClass(WebcamIterator, [{
    key: "summary",
    value: function summary() {
      return "webcam";
    } // Construct a WebcamIterator and start it's video stream.

  }, {
    key: "start",
    // Async function to start video stream.
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.webcamConfig.facingMode) {
                  util.assert(this.webcamConfig.facingMode === 'user' || this.webcamConfig.facingMode === 'environment', function () {
                    return "Invalid webcam facing mode: ".concat(_this2.webcamConfig.facingMode, ". ") + "Please provide 'user' or 'environment'";
                  });
                }

                _context.prev = 1;
                _context.next = 4;
                return navigator.mediaDevices.getUserMedia({
                  video: {
                    deviceId: this.webcamConfig.deviceId,
                    facingMode: this.webcamConfig.facingMode ? this.webcamConfig.facingMode : 'user',
                    width: this.webcamVideoElement.width,
                    height: this.webcamVideoElement.height
                  }
                });

              case 4:
                this.stream = _context.sent;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                // Modify the error message but leave the stack trace intact
                _context.t0.message = "Error thrown while initializing video stream: ".concat(_context.t0.message);
                throw _context.t0;

              case 11:
                if (this.stream) {
                  _context.next = 13;
                  break;
                }

                throw new Error('Could not obtain video from webcam.');

              case 13:
                // Older browsers may not have srcObject
                try {
                  this.webcamVideoElement.srcObject = this.stream;
                } catch (error) {
                  console.log(error);
                  this.webcamVideoElement.src = window.URL.createObjectURL(this.stream);
                } // Start the webcam video stream


                this.webcamVideoElement.play();
                this.isClosed = false;
                return _context.abrupt("return", new Promise(function (resolve) {
                  // Add event listener to make sure the webcam has been fully initialized.
                  _this2.webcamVideoElement.onloadedmetadata = function () {
                    resolve();
                  };
                }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var img;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isClosed) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", {
                  value: null,
                  done: true
                });

              case 2:
                _context2.prev = 2;
                img = browser.fromPixels(this.webcamVideoElement);
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](2);
                throw new Error("Error thrown converting video to pixels: ".concat(JSON.stringify(_context2.t0)));

              case 9:
                if (!this.resize) {
                  _context2.next = 22;
                  break;
                }

                _context2.prev = 10;
                return _context2.abrupt("return", {
                  value: this.cropAndResizeFrame(img),
                  done: false
                });

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](10);
                throw new Error("Error thrown cropping the video: ".concat(_context2.t1.message));

              case 17:
                _context2.prev = 17;
                img.dispose();
                return _context2.finish(17);

              case 20:
                _context2.next = 23;
                break;

              case 22:
                return _context2.abrupt("return", {
                  value: img,
                  done: false
                });

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 6], [10, 14, 17, 20]]);
      }));

      function next() {
        return _next.apply(this, arguments);
      }

      return next;
    }()
  }, {
    key: "needToResize",
    value: function needToResize() {
      // If resizeWidth and resizeHeight are provided, and different from the
      // width and height of original HTMLVideoElement, then resizing and cropping
      // is required.
      if (this.webcamConfig.resizeWidth && this.webcamConfig.resizeHeight && (this.webcamVideoElement.width !== this.webcamConfig.resizeWidth || this.webcamVideoElement.height !== this.webcamConfig.resizeHeight)) {
        return true;
      }

      return false;
    } // Cropping and resizing each frame based on config

  }, {
    key: "cropAndResizeFrame",
    value: function cropAndResizeFrame(img) {
      var _this3 = this;

      return tidy(function () {
        var expandedImage = expandDims(cast(img, 'float32'), 0);
        var resizedImage;
        resizedImage = image.cropAndResize(expandedImage, _this3.cropBox, _this3.cropBoxInd, _this3.cropSize, 'bilinear'); // Extract image from batch cropping.

        var shape = resizedImage.shape;
        return reshape(resizedImage, shape.slice(1));
      });
    } // Capture one frame from the video stream, and extract the value from
    // iterator.next() result.

  }, {
    key: "capture",
    value: function () {
      var _capture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.next();

              case 2:
                return _context3.abrupt("return", _context3.sent.value);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function capture() {
        return _capture.apply(this, arguments);
      }

      return capture;
    }() // Stop the video stream and pause webcam iterator.

  }, {
    key: "stop",
    value: function stop() {
      var tracks = this.stream.getTracks();
      tracks.forEach(function (track) {
        return track.stop();
      });

      try {
        this.webcamVideoElement.srcObject = null;
      } catch (error) {
        console.log(error);
        this.webcamVideoElement.src = null;
      }

      this.isClosed = true;
    } // Override toArray() function to prevent collecting.

  }, {
    key: "toArray",
    value: function toArray() {
      throw new Error('Can not convert infinite video stream to array.');
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(webcamVideoElement) {
        var webcamConfig,
            webcamIterator,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                webcamConfig = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                if (!env().get('IS_NODE')) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('tf.data.webcam is only supported in browser environment.');

              case 3:
                if (webcamVideoElement) {
                  _context4.next = 9;
                  break;
                }

                // If webcam video element is not provided, create a hidden video element
                // with provided width and height.
                webcamVideoElement = document.createElement('video');

                if (!(!webcamConfig.resizeWidth || !webcamConfig.resizeHeight)) {
                  _context4.next = 7;
                  break;
                }

                throw new Error('Please provide webcam video element, or resizeWidth and ' + 'resizeHeight to create a hidden video element.');

              case 7:
                webcamVideoElement.width = webcamConfig.resizeWidth;
                webcamVideoElement.height = webcamConfig.resizeHeight;

              case 9:
                webcamIterator = new WebcamIterator(webcamVideoElement, webcamConfig); // Call async function to initialize the video stream.

                _context4.next = 12;
                return webcamIterator.start();

              case 12:
                return _context4.abrupt("return", webcamIterator);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return WebcamIterator;
}(LazyIterator);